<template>
    <div class="Monitor">
        <div class="title">
            <span class="tt">监控视频</span>
            <span class="all" @click="checkAll" v-if="projectId==1||projectId==18||projectId==19">展开全部</span>
            <!-- <video width="300px" autoplay ref="link" height="300px"  ></video> -->
        </div>
        
        <div class="cont row-center">
            <div class="item" v-for="(item,index) in videoList" :class="{'full':item.isFull}" :key="item.id">
                <div class="box">
                    <video width="100%" muted :id="item.ref" height="100%" style="object-fit:fill" ></video>
                </div>
                <Photovoltaic  v-if="PhotovoltaicShow&&projectId==1&&index==0&&(routeName=='Photovoltaic'||routeName=='Overview')"></Photovoltaic>
                <div class="inall" v-if="!item.isFull">
                    <span  @click="full(item,index)">
                        <img src="@/assets/img/whiteFull.png" alt="">全屏
                    </span>
                </div>
                <div v-else class="all" @click="full(item,index)">
                    <img src="@/assets/img/whiteFull.png" alt="">取消全屏
                </div>
                <div class="novideo" v-show="!item.hls">
                    <img src="@//assets/img/video.png" alt="">
                </div>
            </div>
        </div>
        <!-- :PhotovoltaicShow="PhotovoltaicShow" -->
    </div>
</template>

<script>
import { GetSecurityDevices, _getProjectCamera, _getCameraPlayAddress } from '../../api/power.js'
import Photovoltaic from './Photovoltaic';
import Hls from 'hls.js'
     export default {
         data(){
             return {
                isFull:false,
                videoList:[
                    {
                        id:1,
                        isFull:false,
                        ref:'video1',
                        hls:null,
                        video:null,
                    },
                    {
                        id:2,
                        isFull:false,
                        ref:'video2',
                        hls:null,
                        video:null,
                    },
                    {
                        id:3,
                        isFull:false,
                        ref:'video3',
                        hls:null,
                        video:null,
                    },
                    {
                        id:4,
                        isFull:false,
                        ref:'video4',
                        hls:null,
                        video:null,
                    },
                ],
                refresh:true, // 视频刷新
                PhotovoltaicShow:false,
             }
         },
         components:{
            Photovoltaic
         },
         computed:{
            projectId(){
                return this.$store.getters.projectId
            },
            routeName() {
                return this.$route.params.name;
            },
         },
         mounted(){
            //  this.GetSecurityDevices()
             let _this = this
            //  this.timer = setInterval(()=>{
            //     _this.refresh = false
            //     _this.$nextTick(()=>{
            //         _this.refresh = true
            //     })
            //  }, 1000 * 60 * 15)
             
             this.getProjectCamera()
            // setTimeout(function(){
            //     _this.clearVideo()
            // },2000)

         },
         destroyed(){
            if(this.timer){
                clearInterval(this.timer)
                this.timer = null
            }
         },
         watch: {
            projectId(n,o){
                // this.GetSecurityDevices()
                if(n==18||n==1||n==19||n==13){
                    this.clearVideo()
                    this.videoList = [
                        {
                            id:1,
                            isFull:false,
                            ref:'video1',
                            hls:null,
                            video:null,
                        },
                        {
                            id:2,
                            isFull:false,
                            ref:'video2',
                            hls:null,
                            video:null,
                        },
                        {
                            id:3,
                            isFull:false,
                            ref:'video3',
                            hls:null,
                            video:null,
                        },
                        {
                            id:4,
                            isFull:false,
                            ref:'video4',
                            hls:null,
                            video:null,
                        },
                    ]
                    this.getProjectCamera()
                }
            },
            '$store.getters.areaId'(areaId){
                this.clearVideo()
                this.showCamera(this.$store.state.project.monitorList)
            },
            // routeName(name){
            //     this.clearVideo()
            //     this.showCamera(this.$store.state.project.monitorList)
            // }
         },
         methods:{
            checkAll(){
                if(this.projectId==1){
                    let name = this.$store.state.homeitem.user.realName;
                    let userimg = this.$store.state.homeitem.user.img;
                    window.open("http://chvideo.energydt.cn:7001/chvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
                }else if(this.projectId==18){
                    let name = this.$store.state.homeitem.user.realName;
                    let userimg = this.$store.state.homeitem.user.img;
                    window.open("http://jtvideo.energydt.cn:7001/jtvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
                }else if(this.projectId==19){
                    let name = this.$store.state.homeitem.user.realName;
                    let userimg = this.$store.state.homeitem.user.img;
                    window.open("http://xiehevideo.energydt.cn:7001/xhvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
                }
            },
            // GetSecurityDevices(){
            //     GetSecurityDevices().then((res) => {
            //         let monitorArr = [];
            //         let id = 0;
            //         res.data.data.devices.map((item, index) => {
            //             if (item.device_class_name == "监控设备") {
            //                 monitorArr.push({
            //                     id: id++,
            //                     isFull:false,
            //                     videoName: item.device_name,
            //                     videoCode: JSON.parse(item.device_details).roomName,
            //                 });
            //             }
            //         });
            //         this.videoList = monitorArr.filter((e,l)=>l<=3);
            //     });
            // },
            full(item,index) {
                this.videoList[index].isFull = !this.videoList[index].isFull
              
                if(this.projectId==1&&index==0){
                    if(this.videoList[index].isFull){
                        this.PhotovoltaicShow = true
                    }else{
                        this.PhotovoltaicShow = false
                    }
                }
            },
            async getProjectCamera(){
				
				try{
					let res = await _getProjectCamera({
						projectId:this.$store.getters.projectId
					})
					
					let list = res.data.data.devices.filter(item =>{
						let camera = JSON.parse(item.device_details)
						return camera.ysyDeviceSerial
					})
                    console.log(list);
                    this.$store.commit('setMonitorList', list)
                    this.showCamera(list)
                    
                    // let showCameraList = []
                    // if(this.routeName == 'Overview'){
                    //     showCameraList = list.slice(0, 4)
                    // }else{
                    //     showCameraList = list.filter(camera=>camera.area_id == this.$store.getters.areaId).slice(0, 4)
                    // }
                    
					// console.log(showCameraList)

					// showCameraList.forEach(async (item,index) =>{
					// 	let camera = JSON.parse(item.device_details)
					// 	let sys = await _getCameraPlayAddress({
					// 		channelNo:camera.ysyChannel,
					// 		deviceSerial:camera.ysyDeviceSerial,
					// 		protocol:2
					// 	})

                    //     _this.getStream(sys.data.data, _this.videoList[index].ref)

					// })
				}catch(err){
					console.log(err)
				}
				
			},
            showCamera(list){
                let _this = this

                let showCameraList = []
                if(this.$store.getters.areaId == -1){
                    showCameraList = list.slice(0, 4)
                }else{
                    showCameraList = list.filter(camera=>camera.area_id == this.$store.getters.areaId).slice(0, 4)
                }
                
                console.log(showCameraList)
                // let news = ["http://192.168.34.171:8080/live/test1.m3u8","http://192.168.34.171:8080/live/test2.m3u8","http://192.168.34.171:8080/live/test3.m3u8","http://192.168.34.171:8080/live/test4.m3u8"]
                showCameraList.forEach(async (item,index) =>{
                    let camera = JSON.parse(item.device_details)
                    let obj = {
                        channelNo:camera.ysyChannel,
                        deviceSerial:camera.ysyDeviceSerial,
                        protocol:2
                    }
                    if(_this.projectId==19){
                        obj.quality = 2
                    }
                    let sys = await _getCameraPlayAddress(obj)
                    _this.getStream(sys.data.data, _this.videoList[index].ref)
                    // _this.getStream(news[index], _this.videoList[index].ref)

                })
            },
            getStream(url, id) {
                if(Hls.isSupported()){
                    let current = this.videoList.find(item =>item.ref == id)
                    console.log(current);
                    if(!current.hls){
                        current.hls = new Hls()
                        current.video = document.getElementById(id);
                        
                        current.hls.loadSource(url);
                        current.hls.attachMedia(current.video)
                        current.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                            current.video.play();
                            console.log("加载成功");
                        });
                    }
                }
            },
            clearVideo(){
                this.videoList.forEach(item =>{
                    if(item.hls){
                        item.video.pause()
                        item.hls.destroy()
                        item.hls = null
                        item.video = null
                        console.log('销毁视频');
                    }
                })
            }
        },
        
        beforeDestroy(){
            this.clearVideo()
        }
     }
     </script>
<style lang="less" scoped>
    .Monitor{
        padding:10rem 12rem;
        .title{
            overflow: hidden;
            line-height: 32rem;
            margin-bottom: 5rem;
            .tt{
                font-size: 16rem;
                font-weight: bold;
            }
            .all{
                display: inline-block;  
                float: right;
                text-align: center;
                line-height: 32rem;
                width: 112rem;
                height: 32rem;
                color: #ffffff;
                background: #0D94FF;
                border-radius: 2rem;
                cursor: pointer;
            }
        }
        .cont{
            justify-content: space-between;
            
            .item{
                .w(280);
                .h(128);
                margin-bottom: 8rem;
                position: relative;

                .novideo{
                    .w(280);
                    .h(128);
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: rgba(0, 43, 102, 0.04);
                    &>img{
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }

                .img{
                    width: 100%;
                    height: 100%;
                }
                .box{
                    height: 100%;
                    width: 100%;
                }
                .all{
                    position: absolute;
                    text-align: right;
                    color: #ffffff;
                    bottom: 10px;
                    right: 10px;
                    font-size: 26rem;
                    padding: 0 10rem;
                    text-align: right;
                    cursor: pointer;
                    img{
                        vertical-align: -5px;
                        margin-right: 10px;
                    }
                }
                .inall{
                    position: absolute;
                    background: rgba(66, 66, 66, 0.4);
                    width: 100%;
                    height: 30rem;
                    line-height: 30rem;
                    text-align: right;
                    color: #ffffff;
                    bottom: 0;
                    left: 0;
                    font-size: 16rem;
                    padding: 0 10rem;
                    text-align: right;
                    span{
                        cursor: pointer;
                    }
                    img{
                        width: 14px;
                        height: 14px;
                        vertical-align: -2rem;
                        margin-right: 5rem;
                    }
                }
            }
            
            .full{
                width: 100vw;
                height: 100vh;
                position: fixed;
                top: 0;
                left: 0;
                z-index: 99;
                background-color: #000000;
                .box{
                    position: absolute;
                    width: 1536px;
                    height: 937px;
                    
                    left: 50%;
                    top: 50%;
                    margin-left: -768px;
                    margin-top: -468px;
                    transform: translate(0, 0);
                }
                
                .all{
                    position: fixed;
                }
            }
        }
    }
</style>